<template>
    <h2 class="page-subtitle"><slot></slot></h2>
</template>

<script>
  module.exports = {
    // data: function() {
    //   return {
    //        title: ''
    //   }
    // }
  }
</script>

<style scoped lang="scss">

    @import './variables';

    .page-subtitle {
        color: $dark-blue;
        font-family: $title-font;
        font-size: 1rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.61;
        letter-spacing: normal;
        text-align: center;
    }

</style>
